import { apiRequest } from '../../lib/api-client.js';

export interface McpKeyRow {
  id: number;
  name: string;
  server_id: number | null;
  tenant_id: number | null;
  master: boolean;
  can_write: boolean;
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
  /** Nome do super-user que criou; null se ele foi apagado. */
  dono: string | null;
}

export interface CreateMcpKeyInput {
  name: string;
  server_id?: number;
  tenant_id?: number;
  can_write: boolean;
}

export interface CreatedMcpKey {
  id: number;
  name: string;
  /** Aparece UMA vez. Depois só existe o hash. */
  token: string;
  master: boolean;
  can_write: boolean;
}

export const mcpApi = {
  list: () => apiRequest<{ keys: McpKeyRow[] }>('/api/mcp-keys').then((r) => r.keys),
  create: (body: CreateMcpKeyInput) =>
    apiRequest<CreatedMcpKey>('/api/mcp-keys', { method: 'POST', body }),
  revoke: (id: number) => apiRequest<void>(`/api/mcp-keys/${id}`, { method: 'DELETE' }),
};
